import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { SalesCenterWebhookModel } from '@user/store/scWebHooks'

export function useHandlers() {
  const { setFieldValue } = useFormikContext<SalesCenterWebhookModel>()

  const handleChange = useCallback(
    (value: string | null) => {
      setFieldValue('webhookType', value)
    },
    [setFieldValue],
  )

  return {
    handleChange,
  }
}
